<div class="row justify-content-md-center">
  <h3> Aggiunta Parco </h3>

</div>
<div class="row justify-content-md-center">
  <div class="col col-lg-2">
  </div>
  <div class="col  col-lg-8">

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <p>Compila questo campo per creare un nuovo parco auto</p>

      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" >Nome parco</span>
          </div>
          <input type="text" formControlName="name" class="form-control"
                 [class.is-invalid]="submitted && cp.name.errors" />
          <div *ngIf="submitted && cp.name.errors" class="invalid-feedback">
            <div *ngIf="cp.name.errors.required">Il nome è un campo obbligatoriox</div>
            <div *ngIf="cp.name.errors.minlength">Nome troppo corto</div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="parkTypeSelect">Scegli tipo di parco</label>
        <select class="form-control" id="parkTypeSelect" formControlName="type">
          <option *ngFor="let parkType of parkTypes" [ngValue]="parkType['id']">
            {{ parkType['name'] }}
          </option>
        </select>
      </div>


      <div *ngIf="errorMessage" class="alert alert-danger my-3">{{errorMessage}}</div>
      <div *ngIf="success" class="alert alert-success my-3">Parco creato</div>

      <button [disabled]="loading" class="btn btn-primary">
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
        crea parco
      </button>

    </form>

  </div>
  <div class="col col-lg-2">
  </div>
</div>

